<template>
  <div id="product-external-edit-url">
    <b-form @submit.prevent="onSubmit({ data: data, url })">
      <b-row>
        <b-col md="12">

          <b-form-group
            label="Url"
            label-for="url"
          >
            <b-form-input
              id="url"
              v-model="url"
              placeholder="Url Produk"
            />
          </b-form-group>
        </b-col>

        <b-col
          md="12"
          class="text-right"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="isLoading"
          >
            <b-spinner
              v-show="isLoading"
              small
            />
            Simpan
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BFormGroup,
  BFormInput,
  BForm,
  BRow,
  BCol,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BForm,
    BRow,
    BCol,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      url: this.data.product.url,
    }
  },
  computed: {
    ...mapState('products', ['isLoading']),
  },
  methods: {
    ...mapActions('products', ['updateUrlProductExternal']),
    async onSubmit(data) {
      await this.updateUrlProductExternal(data)
      this.$emit('finish')
      // try {
      //
      //   this.$store.commit('products/SET_OPEN_EDIT', false)
      //
      //   this.$swal({
      //     title: 'Berhasil!',
      //     text: 'Url Produk Eksternal berhasil diubah.',
      //     icon: 'success',
      //     timer: 3000,
      //     customClass: {
      //       confirmButton: 'btn btn-primary',
      //     },
      //     buttonsStyling: false,
      //   })
      // } catch (error) {
      //   this.$store.commit('products/SET_OPEN_EDIT', false)
      //
      //   this.$swal({
      //     title: 'Error!',
      //     text: error.message,
      //     icon: 'error',
      //     timer: 3000,
      //     customClass: {
      //       confirmButton: 'btn btn-primary',
      //     },
      //     buttonsStyling: false,
      //   })
      // }
    },
  },
}
</script>
